<template>
  <div class="category-page">
    <Search />
    <Breadcrumbs />
    <div class="category-page__title">
      <div class="category-page__title-wrap">
        <h1 class="main-title">
          {{ street ? street : breadcrumbs[breadcrumbs.length - 1]?.name }}
        </h1>
        <p class="category-page__subtitle">
          (Total Found: <strong>{{ filterProds.length }}</strong
          >)
        </p>
      </div>
      <div class="category-page__select-wrap">
        <Pagination gridList="true" />
      </div>
    </div>
    <Categories />
    <div class="category-page__body">
      <div class="category-page__col" :class="{ active: isMapOpen }">
        <Products />
      </div>
      <div
        class="category-page__col category-page__col--map"
        :class="{ active: isMapOpen }"
      >
        <GoogleMap v-if="isMapOpen" />
      </div>
    </div>
    <Pagination />
    <section class="description description--category description--left-desc">
      <div class="description__wrap " v-html="description">
          
      </div>
    </section>
    <MobMapBtn />
    <transition name="slide-up-fade" mode="out-in">
      <div v-if="loading" class="overlay overlay--loader">
        <div class="loader--windows">
          <div class="loader__dot loader__dot--1"></div>
          <div class="loader__dot loader__dot--2"></div>
          <div class="loader__dot loader__dot--3"></div>
          <div class="loader__dot loader__dot--4"></div>
          <div class="loader__dot loader__dot--5"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Products from "../components/category-page/Products";
import Search from "../components/category-page/Search";
import Breadcrumbs from "../components/category-page/Breadcrumbs";
import Categories from "../components/category-page/Categories";
import Pagination from "../components/category-page/Pagination";
import MobMapBtn from "../components/category-page/MobMapBtn";
import GoogleMap from "../components/GoogleMap";
import init from "../mixins/init";
export default {
  name: "App",
  mixins: [init],
  components: {
    Products,
    Search,
    Breadcrumbs,
    Categories,
    Pagination,
    GoogleMap,
    MobMapBtn,
  },
  created() {
    this.init();
  },
};
</script>
